import React, { useState } from "react"
import ForFinancePaymentItem from "./ForFinancePaymentItem"
import { ForFinancePayment } from "../types"

interface ForFinancePaymentListProps {
  forFinancePayments: ForFinancePayment[]
}

const ForFinancePaymentList: React.FC<ForFinancePaymentListProps> = ({ forFinancePayments }) => {
  const [isOpen, setIsOpen] = useState(false)

  const toggleOpen = () => {
    setIsOpen(!isOpen)
  }

  return (
    <div className="bg-white">
      <button
        onClick={toggleOpen}
        className="flex w-full items-center gap-2 px-5 py-3 text-left hover:bg-gray-50"
      >
        <svg
          className={`h-2 w-3 transform transition-transform ${isOpen ? "rotate-180" : "rotate-0"}`}
          fill="currentColor"
          viewBox="0 0 12 8"
        >
          <path d="M6 8L0 0h12L6 8z" />
        </svg>
        <span className="text-lg text-black">対象の立替申請</span>
      </button>

      {isOpen && (
        <div className="px-5 py-3">
          {forFinancePayments.length > 0 ? (
            <div className="flex flex-col gap-2">
              {forFinancePayments.map((payment) => (
                <ForFinancePaymentItem key={payment.id} payment={payment} />
              ))}
            </div>
          ) : (
            <div className="text-sm text-gray-500">対象の立替申請がありません</div>
          )}
        </div>
      )}
    </div>
  )
}

export default ForFinancePaymentList
